import { isBusinessRuleType } from "src/business/extensions/isBusinessRuleType";
import { ZExtension } from "src/business/extensions/ZExtension";

import { ZExtensionFormValues } from "./extensionCardPageStore";

export const mapExtensionToFormValues = (
  extension: ZExtension | null,
): ZExtensionFormValues => {
  const result: ZExtensionFormValues = {
    name: extension?.name ?? "",
    description: extension?.description ?? "",
    version: extension?.version ?? "",
    type: extension?.type ?? undefined,
    file: extension?.file ?? null,
  };

  if (isBusinessRuleType(result.type)) {
    result.scope = extension?.scope ?? undefined;
  }
  return result;
};
